// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"497e6ff0","732":"9d40c925"}[chunkId] + ".chunk.js");